import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=3217413d&scoped=true&xmlns%3Av-lazy=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./similar.vue?vue&type=script&lang=js&"
export * from "./similar.vue?vue&type=script&lang=js&"
import style0 from "./similar.vue?vue&type=style&index=0&lang=less&"
import style1 from "./similar.vue?vue&type=style&index=1&id=3217413d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217413d",
  null
  
)

export default component.exports